import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const i = t((s, r) => /* @__PURE__ */ o.jsx(
  a,
  {
    ref: r,
    ...s,
    image: (e) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...e,
        children: /* @__PURE__ */ o.jsx("path", { fill: "currentColor", d: "M13 15V1h-2v14zM5 15V1H3v14z" })
      }
    )
  }
));
i.displayName = "PauseIcon";
export {
  i as PauseIcon,
  i as default
};
//# sourceMappingURL=index.js.map
